export const iconFontAwesomeChildhoodRobot = (
	<i className="fa-solid fa-robot"></i>
);
